import React from "react";
import "./HairTreatmentLandingMission.css";
import HairTreatmentLandingMissionCard from "./HairTreatmentLandingMissionCard";

const HairTreatmentLandingMissionMain = () => {
  return (
    <div className="hairTreatmentLandingMissionMain">
      <HairTreatmentLandingMissionCard />
      <HairTreatmentLandingMissionCard />
      <HairTreatmentLandingMissionCard />
      <HairTreatmentLandingMissionCard />
    </div>
  );
};

export default HairTreatmentLandingMissionMain;
